import {Container} from "./styles";

import githubIcon from "../../assets/github.png";
import instagramIcon from "../../assets/instagram.png";

export function Footer(){
  return(
    <Container className="footer">
      <a href="/" className="logo">
        <span>S</span>
        <span>Modi</span>
      </a>
      <div>
        <p>This site was made with <span>❤️</span></p>
      </div>

      <div className="social-media">
        <a href="https://github.com/SabadModi" target="_blank" rel="noreferrer">
          <img src={githubIcon} alt="GitHub" />
        </a>

        <a href="https://www.instagram.com/sabad.modi/" target="_blank" rel="noreferrer">
          <img src={instagramIcon} alt="Instagram" />
        </a>
      </div>
      
    </Container>
  )
}